module.exports = __webpack_public_path__ + "assets/images/character-happy.3d45fe15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/onboarding/character-happy.svg
// module id = 2165
// module chunks = 1612